
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '@/components/auth/LoginForm';
import { Wallet } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { user, profile, loading } = useAuth();

  useEffect(() => {
    console.log('Login page - User:', user?.id, 'Profile:', profile, 'Loading:', loading);
    
    // Only redirect if we have both user AND profile, and we're not loading
    if (!loading && user && profile) {
      console.log('Login: User authenticated, redirecting to dashboard');
      if (profile.role === 'admin') {
        navigate('/admin/dashboard', { replace: true });
      } else if (profile.role === 'author') {
        navigate('/author/dashboard', { replace: true });
      }
    }
  }, [user, profile, loading, navigate]);

  // Don't render login form if user is already authenticated
  if (!loading && user && profile) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-gray-50">
      <div className="mb-8 text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-royalty-600 p-2 rounded-full">
            <Wallet className="h-8 w-8 text-white" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-royalty-700">Author Royalty Management</h1>
        <p className="text-gray-600 mt-2">Manage royalties, payments, and support with ease</p>
      </div>
      
      <LoginForm />
      
    </div>
  );
};

export default Login;
